import bellAudio from "@/audio/bell.mp3";

export const playBellAudio = async () => {
  const sound = new Audio(bellAudio);
  await sound.play();
};

export default {};
